var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrayonIQLogosNegativeMarketIQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "87.96 86.75 794.48 203.65",
    style: {
      enableBackground: "new 0 0 970.35 377.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0{fill:#FFFFFF;}\r\n    .st1{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 640.27,
    y: 194.81,
    className: "st0",
    width: 12.82,
    height: 15.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M786.76,145.18c-17.82,0-36.93,12.05-36.93,38.71s19.11,38.52,36.93,38.52c4.31,0,8.63-0.74,12.99-2.18         L781,199.74l18.89-15.85l18.74,20.53c3.06-5.6,4.87-12.24,4.87-20.53C823.5,157.23,804.43,145.18,786.76,145.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M853.05,184.07c0-40.51-30.43-66.61-66.29-66.61c-36.04,0-66.48,26.1-66.48,66.61         c0,40.33,30.43,66.43,66.48,66.43c11.88,0,23.42-2.88,33.13-8.29l15.68,17.29l18.74-15.85l-15.68-17.1         C847.63,215.55,853.05,201.18,853.05,184.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M853.05,184.07c0-40.51-30.43-66.61-66.29-66.61c-36.04,0-66.48,26.1-66.48,66.61         c0,40.33,30.43,66.43,66.48,66.43c11.88,0,23.42-2.88,33.13-8.29l15.68,17.29l18.74-15.85l-15.68-17.1         C847.63,215.55,853.05,201.18,853.05,184.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M657.79,86.75v108.06h13.81v15.9h-13.81v79.69h224.65V86.75H657.79z M709.99,246.48h-23.54v-52.13h23.54         V246.48z M709.99,182.58h-23.54v-23.54h23.54V182.58z M835.56,259.5l-15.68-17.29c-9.7,5.42-21.25,8.29-33.13,8.29         c-36.04,0-66.48-26.1-66.48-66.43c0-40.51,30.43-66.61,66.48-66.61c35.86,0,66.29,26.1,66.29,66.61c0,17.1-5.42,31.48-14.42,42.47         l15.68,17.1L835.56,259.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.77,250.91l-11.48-94.15l-39.27,80.7h-14.17l-39.63-80.7l-11.3,94.15H87.96l15.06-123.56h14.71         l44.12,91.64l43.94-91.64h14.71l15.24,123.56H219.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.21,167.16v83.75h-15.6v-13.27c-5.56,9.68-17.75,15.06-29.77,15.06c-22.96,0-41.96-17.4-41.96-43.76         c0-26.54,18.83-43.58,41.79-43.58c12.55,0,24.39,5.02,29.95,14.88v-13.09H332.21z M316.61,208.77c0-18.11-14.71-28.69-28.51-28.69         c-15.24,0-27.44,11.84-27.44,28.69c0,16.68,12.2,29.23,27.44,29.23C303.16,238,316.61,226.7,316.61,208.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.3,168.59l-2.51,14.71c-4.48-2.15-8.97-2.87-12.2-2.87c-16.68,0-23.31,17.75-23.31,39.81v30.67H350.5         v-83.75h15.78v19.01c4.3-14.71,12.37-20.8,23.49-20.8C395.69,165.37,401.79,166.98,404.3,168.59z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M465.68,250.85l-38.56-40.89v40.89h-15.6V121.36h15.6v75.32l29.05-29.59h21.7l-35.87,36.23l44.65,47.52H465.68         z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.93,215.7h-68.15c2.33,14.89,13.09,22.24,27.44,22.24c10.22,0,19.73-4.3,24.39-12.73l13.63,5.38         c-7.35,14.53-22.42,22.06-38.56,22.06c-23.85,0-43.04-17.4-43.04-43.94c0-26.54,19.19-43.4,43.04-43.4         c23.85,0,41.61,16.86,41.61,43.4C566.29,211.03,566.11,213.36,565.93,215.7z M550.69,202.25c-1.97-14.35-12.2-22.24-26-22.24         c-14.17,0-24.21,7.17-26.72,22.24H550.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617.4,180.55h-18.11v70.3h-15.6v-70.3h-15.06V167.1h15.06v-31.74h15.6v31.74h18.11V180.55z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrayonIQLogosNegativeMarketIQ);
export default __webpack_public_path__ + "static/media/Crayon_iQ_logos_negative_Market_iQ.07bc51f0674e9e157d3142bfbdac5fdc.svg";
export { ForwardRef as ReactComponent };